import { ROUTE_AUTH_LOGOUT, ROUTE_LOGIN, ROUTE_REGISTER } from "@/assets/js/consts/apiRoutes.consts.js";
import { axios_post } from "@/assets/js/functions/axios_helpers.js";

const logoutUser = params => axios_post(ROUTE_AUTH_LOGOUT, params);

const login_password = params => axios_post(ROUTE_LOGIN, params);

const register_user = params => axios_post(ROUTE_REGISTER, params);

export {
  logoutUser,
  login_password,
  register_user,
};
